import { render, staticRenderFns } from "./InsuranceProvidersTable.vue?vue&type=template&id=771a533a"
import script from "./InsuranceProvidersTable.vue?vue&type=script&lang=js"
export * from "./InsuranceProvidersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports